import { 
	createSlice, 
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import { envAwarePost, envAwareFormSubmit} from '../util/util'

import {
	reset as resetProgress
} from '../features/Metrics/slice'

export const createMetric = createAsyncThunk(
	'createMetric',
	async (payload,{dispatch}) => {
		dispatch(resetProgress())
		return envAwarePost('api/metrics/api/',{
			action: 'createMetric',
			client_id: payload.client_Id,
			type:  payload.clientName,
			category_id: payload.category_id,
			name: payload.itemName,
			description: payload.itemDesc,
			integration_id: payload.integrationId,
			unit_id:payload.unit_id,
			add_to_all:payload.add_to_all
		})
	}
)

export const updateMetric = createAsyncThunk(
	'updateMetric',
	async (payload,{dispatch}) => {
		dispatch(resetProgress())
		return envAwarePost('api/metrics/api/',{
			action: 'updateMetric',
			...payload
		})
	}
)

export const createCategory = createAsyncThunk(
	'createCategory',
	async payload => envAwarePost('api/metrics/api.php',{
			action: 'createCategory',
			name:  payload.inputValue
		}
))

export const logMetricProgress = createAsyncThunk(
	'logMetricProgress_DEPRECATED',
	async payload => envAwarePost(
		'api/metrics/api/',
		{
			action: "logMetricProgress",
			date: payload.datePicker,
			notes: payload.notes,
			metric_id:payload.metric_id,
			value:payload.value,
			minutes:payload.minutes,
			seconds:payload.seconds,
		}
	)
)

export const getAllMetricsByCategory = createAsyncThunk(
	'getAllMetricsByCategory',
	async payload => envAwarePost('api/metrics/api.php',
		{
			action: "getAllMetricsByCategory",
			type: payload.type,
			client_id: payload.client_Id,
			include_progress_data: payload.include_progress_data,
			include_empty_groups:payload.include_empty_groups
		}
	)
)

export const getClientMetrics = createAsyncThunk(
	'getClientMetrics',
	async payload => envAwarePost('api/metrics/api.php',
	{
		action: 'getClientMetrics',
		client_id: payload.clientId
	})
)

export const getAllCategories = createAsyncThunk(
	'getAllCategories',
	async payload => envAwarePost('api/metrics/api.php',
	{
		action: 'getAllCategories',
		client_id: payload.clientId
	})
 )

export const updateMetricOrder = createAsyncThunk(
	'updateMetricOrder',
	async payload => envAwarePost('api/metrics/api.php', {
			action: "updateMetricOrder",
			orderDiff: payload.orderDiff,
			client_id: payload.clientId,
	}
))

export const updateMetricGroupings = createAsyncThunk(
  'updateMetricGroupings',
  async payload => envAwareFormSubmit({
    path:'api/metrics/api.php',
    payload: {
      action: "updateMetricGroupings",
      client_id: payload.clientId,
      use_explicit: 1,
      update: payload.update
    }
  })
)




// name:itemName,
// description:itemDesc,
// integration_id:integrationId,
// metric_id:assessmentID,
// unit_id:selectedUnit,
// category: category,


export const editMetric = createAsyncThunk(
	'editMetric',
	async payload => envAwareFormSubmit({
		path:'api/metrics/api.php',
		payload: {
			action: "editMetric",
			item_db_name: payload.name,
			description: payload.description, //should hold the description
			integration_id: payload.integration_id,
			item_db_id: payload.metric_id,
			category: payload.category,
		}
	})
)

export const editMetricProgress = createAsyncThunk(
	'editMetricProgress',
	async payload => envAwareFormSubmit({
		path:'api/metrics/api.php',
		payload: {
			action: "editMetricProgress",
			statID: payload.statsID,
			assessmentID: payload.assessmentID,
			datepicker: payload.datepicker,
			newValue: payload.newValue,
			newNote: payload.newNote,
		}
	})
)

export const categorizeMetric = createAsyncThunk(
	'categorizeMetric',
	async payload => envAwarePost(
		'api/metrics/api.php',
		{
			action: 'categorizeMetric',
			category_id:payload.category_id,
			metric_id:payload.assessmentID		
		}
	)
)

export const deleteCategory = createAsyncThunk(
  'deleteCategory',
  async payload => envAwarePost('api/metrics/api.php',{
      action: "deleteCategory",
      category_id:payload.category_id,
	  id:payload.category_id
  }
))


export const deleteMetric = createAsyncThunk(
	'deleteMetric',
	async (payload,{dispatch}) => {
		dispatch(resetProgress())
		return envAwarePost("api/metrics/api.php",{
			action: "deleteMetric",
			client_id: payload.client_Id,
			metric_id: payload.id
		})
	}
)

export const deleteProgressData = createAsyncThunk(
	'deleteProgressData',
	async payload => envAwarePost(
		'api/metrics/api.php',
		{
			action: "deleteProgressData",
			statID: payload.statID,
			assessmentID: payload.assessmentID
		}
	)
)

const metricsNormalize = (categoryGroups) => {
	let metricEntities={}
	let flatMetric;
	let progressIds=[]
	categoryGroups.forEach(category => {
		category.metrics.forEach(metric => {
			flatMetric = metric
			progressIds=[]
			flatMetric.categorization = metric.categorization.name
			metricEntities[metric?.metric_id]=flatMetric
		})
	})
	return metricEntities
}
const categoriesNormalize = (categoryGroups) => {
	let categoryEntities = {}
  let metrics;
	let flatCategory;
	categoryGroups.forEach(category => {
    metrics = category.metrics.map(m => m.metric_id)
		flatCategory = category
		flatCategory.metrics = metrics
		categoryEntities[category.category_id]=flatCategory
	})
	return categoryEntities
}

const metricNormalize = (metric) => {
	let entity ={}
	entity = {...metric}
	entity.categorization=metric.categorization.name
	return entity
}
const manyMetricNormalize = (metrics) => {
	//check wether metric is {assessment_name:"metric", ....} or {{}, {}, {}}
	let entities = []
	let name;
	Object.values(metrics).forEach((metric)=> {
		if(metric.categorization.name){
			name = metric.categorization.name
			metric.categorization = name
			entities.push(metric)
		} else {
			entities.push(metric)
		}
	})
	return entities
}

const categoryNormalize = (categoryData) =>{
	let category = categoryData.name
	let category_id = categoryData.id
	return {
		category,
		category_id,
		metrics:[]
	}
}

const updateObject = (orderDiff) => {
	// console.log('HERE ORDERDIFF',orderDiff)
	let updateObject = []
	for (const [key, value] of Object.entries(orderDiff)){
		let id = key
		// console.log('ID: ', id)
		updateObject = [...updateObject, {id, changes:{preferred_order:value}}]
	}
	// console.log('updateObject: ', updateObject)
	return updateObject
}

const metricsAdapter = createEntityAdapter({
  selectId:ent=>ent?.metric_id,
	sortComparer: (a, b) => {
		let textA = parseInt(a.preferred_order);
		let textB = parseInt(b.preferred_order);
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	},
  status:'idle',
})

const categoriesAdapter = createEntityAdapter({
  selectId:ent=>ent?.category_id,
  status:'idle',
})


const metricListSlice = createSlice({
	name: 'metrics',
	initialState:metricsAdapter.getInitialState({
		status:'init',
		categories: categoriesAdapter.getInitialState(),
	}),
	reducers: {
		updateLocalMetricOrder : (state, action) => {
			let update = updateObject(action.payload.orderObj)
			metricsAdapter.updateMany(state, update)
		}
	},
	extraReducers:{
		[updateMetricOrder.pending] : (state,action) => {
			state.status = 'loading'
		},
		[updateMetricOrder.fulfilled] : (state,action) => {
			 let update = updateObject(action.meta.arg.orderDiff)
			 metricsAdapter.updateMany(state, update)
			state.status="idle"
		},
		[getAllMetricsByCategory.pending] : (state)=>{
			state.status = 'loading'
		},
		[getAllMetricsByCategory.fulfilled] : (state,action)=>{
			const {success,data} = JSON.parse(JSON.stringify(action.payload))
			state.status = 'idle'
			if(success == 1) {
				let metrics = metricsNormalize(JSON.parse(JSON.stringify(data))) //stringified to deep copy data
				let categories=categoriesNormalize(JSON.parse(JSON.stringify(data)))
				metricsAdapter.setAll(state,metrics)
				categoriesAdapter.setAll(state.categories,categories)
			}
		},
		[createMetric.pending] : (state)=>{
			state.status = 'loading'
		},
		[createMetric.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.status = 'idle'
				if(data.assessment_name){
					let metric = metricNormalize(data)
					metricsAdapter.addOne(state,metric)
				} else {
					let metrics = manyMetricNormalize(data)
					// metricsAdapter.addMany(state,metrics) // this adds all to list, messes 
				}

			} 
		},
		[createCategory.pending] : (state)=>{
			state.status = 'loading'
		},
		[createCategory.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.status = 'idle'
				let category = categoryNormalize(data)
				categoriesAdapter.addOne(state.categories,category) 
			}
		},
		[logMetricProgress.pending] : (state)=>{
			state.status = 'loading'
		},
		[logMetricProgress.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.status = 'idle'
			}
		},
		[updateMetric.pending] : (state,action)=>{
			state.status = 'loading'
			metricsAdapter.updateOne(state,{
				id:action.meta.metric_id,
				changes:action.meta.arg
			})
		},
		[updateMetric.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.status = 'idle'
			}
		},
		[editMetricProgress.pending] : (state)=>{ // fasdfasdf
			state.status = 'loading'
		},
		[editMetricProgress.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success == 1){
				state.status = 'idle'
			}
		},
		// [categorizeAndEditMetric.pending] : (state)=>{
		// 	state.status = 'loading'
		// },
		// [categorizeAndEditMetric.fulfilled] : (state,action)=>{
		// 	const {success,data} = action.payload
		// 	if(success == 1){
		// 		state.status = 'idle'
		// 	}
		// },

		[categorizeMetric.pending] : (state)=>{
			state.status = 'loading'
		},
		[categorizeMetric.fulfilled] : (state,action)=>{
			state.status = 'idle'
			const {success,data} = action.payload
			if(success == 1) {
				let metric = metricNormalize(data)
				let updateObject = {id:metric.metric_id, changes:metric}
				metricsAdapter.updateOne(state,updateObject)
			}
		},
		[deleteCategory.pending] : (state)=>{
			state.status = 'loading'
		},
		[deleteCategory.fulfilled] : (state,action)=>{
			state.status = 'idle'
			const {success,data} = action.payload
			let id = action.meta.arg.category_id
			if(success == 1) {
				categoriesAdapter.removeOne(state.categories,id)
			}
		},
		[deleteMetric.pending] : (state)=>{
			state.status = 'loading'
		},
		[deleteMetric.fulfilled] : (state, action) => {
			state.status = 'idle'
			const {success,data} = action.payload
			if(success == 1) {
				let id = parseInt(action.meta.arg.id)
				metricsAdapter.removeOne(state,id)
			}
		},
		[deleteProgressData.pending] : (state)=>{
			state.status = 'loading'
		},
		[deleteProgressData.fulfilled] : (state, action) => {
			const {success,data} = action.payload
			if(success == 1) {
				state.status = 'idle'
			}
		},
	}

})

export const {
	selectAll: selectAllMetrics,
	selectById: selectMetricById,
	selectIds: selectMetricsIds,

} = metricsAdapter.getSelectors(state => state.metrics)

export const {updateLocalMetricOrder} = metricListSlice.actions


export default metricListSlice.reducer
